import service from '@/store/services/fiscalize-device-service';

const state = {
    cashRegister: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, cashRegister) => {
        state.cashRegister = cashRegister;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    tokenRefresh({ commit, dispatch }, params) {
        return service.tokenRefresh(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    getDevice({ commit, dispatch }, params) {
        return service.getDevice(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((cashRegister) => { commit('SET_RESOURCE', cashRegister); });
    },
};

const getters = {
    cashRegister: state => state.cashRegister
};

const fiscalizeDevice = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default fiscalizeDevice;